module.exports = __webpack_public_path__ + "img/2-IMG_3063.fe4740c4.png";